import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from '@prism/spinner';

class PrismSpinner extends React.PureComponent {
    static propTypes = {
        color: PropTypes.string,
        size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        className: PropTypes.string
    };

    render() {
        const { className, ...spinnerProps } = this.props;

        const containerClassName = classNames('prism-sandbox', className);

        return (
            <span className={containerClassName}>
                <Spinner {...spinnerProps} />
            </span>
        );
    }
}

export default PrismSpinner;
